import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { forwardRef, Provider } from '@angular/core';
import { UiControlValidatorDirective } from './ui-control-validator';
import { UiControlValueAccessorDirective } from './ui-control-value-accessor';

export const provideCustomCVA = (component: unknown): Provider[] => {
  return [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => component),
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: forwardRef(() => component),
    },
    {
      provide: UiControlValidatorDirective,
      useExisting: forwardRef(() => component),
    },
    {
      provide: UiControlValueAccessorDirective,
      useExisting: forwardRef(() => component),
    },
  ];
};
